import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LockKey, SignIn } from "@phosphor-icons/react";
import { useAuth } from "../../context/AuthContext";

export default function LoginPage() {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (isAuthenticated) navigate("/admin", { replace: true });
  }, [isAuthenticated, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(username.trim(), password);
      navigate("/admin", { replace: true });
    } catch (err) {
      const msg =
        err?.response?.status === 401
          ? "Credenziali non valide"
          : "Errore di connessione. Riprova.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090b] text-[#FFFFF0] px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full border border-[#C5A059]/40 mb-6">
            <LockKey size={24} weight="light" className="text-[#C5A059]" />
          </div>
          <div className="text-xs uppercase tracking-[0.25em] text-[#C5A059] mb-3">
            Area riservata
          </div>
          <h1 className="font-serif text-4xl lg:text-5xl leading-tight">
            Alpi Resort — Admin
          </h1>
          <p className="text-white/50 mt-4 text-sm">
            Accedi per gestire prenotazioni e contenuti del sito.
          </p>
        </div>

        <form onSubmit={onSubmit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-xs uppercase tracking-[0.2em] text-white/60 mb-2">
              Username
            </label>
            <input
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={loading}
              data-testid="admin-login-username"
              className="w-full bg-transparent border border-white/15 px-4 py-3 text-base focus:border-[#C5A059] outline-none transition-colors disabled:opacity-50"
              required
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.2em] text-white/60 mb-2">
              Password
            </label>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              data-testid="admin-login-password"
              className="w-full bg-transparent border border-white/15 px-4 py-3 text-base focus:border-[#C5A059] outline-none transition-colors disabled:opacity-50"
              required
            />
          </div>

          {error && (
            <div
              className="border border-red-500/40 bg-red-500/5 text-red-300 px-4 py-3 text-sm"
              data-testid="admin-login-error"
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !username || !password}
            data-testid="admin-login-submit"
            className="w-full bg-[#C5A059] text-black px-6 py-4 text-xs uppercase tracking-[0.25em] font-medium inline-flex items-center justify-center gap-3 hover:bg-[#D4AF37] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? "Accesso in corso…" : (<>Accedi <SignIn size={16} weight="bold" /></>)}
          </button>
        </form>

        <p className="text-white/30 text-xs text-center mt-10">
          Hai perso la password? Contatta l'amministratore di sistema.
        </p>
      </div>
    </div>
  );
}
